import { OnInit, OnDestroy, Component, Optional, Inject } from '@angular/core';
import { IContextService, DomainContext, IAuthorizationService } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-rgl-grid',
    templateUrl: './dojo-rgl-grid.component.html'
})
export class DojoRglGridComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    nxiRestServiceUrl: any;
    title: string;
    showPCLink: boolean = false;
    group: boolean = false;
    isCitisite: boolean = false;
    isdesktop: boolean = false;
    constructor(private contextService: IContextService,
                private nxiRestService: NxiRestService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                private authService: IAuthorizationService,
                @Optional() @Inject('AppSettings') appSettings: any) {
            this.nxiRestServiceUrl = this.nxiRestService.serviceUrl;
            this.showPCLink = appSettings.entitlementJson.includes('HISTORIC_DATA');
            if (appSettings.ibdConfigMap.IBD && appSettings.ibdConfigMap.IBD === 'C01') {
                this.isCitisite = true;
            }
            if (appSettings.deviceType && appSettings.deviceType === 'desktop') {
                this.isdesktop = true;
            }
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            if (domainContext.domain === 'group') {
                this.group = true;
            }
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;

            this.getRglGrid();
        });
    }

    ngOnDestroy(): void {
        console.log('In dojo RGL Grid destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyRglGrid();
        }
    }
    renderDojoWidget(rglGridDojoParam: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            rglGridDojoParam.nxiRestBaseUrl = this.nxiRestServiceUrl;
            dojoApp.renderRglGrid(this.inputValue, rglGridDojoParam);
        }
    }
    getRglGrid() {
        if (this.inputValue !== '' && this.acctRef !== '') {
            this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'rgl').subscribe(
                resp => {
                    console.log('Retrived common RGL Grid params : ', resp.response);
                    if (resp.response) {
                        resp.response.storeUrl = this.nxiRestService.serviceUrl + resp.response.storeUrl;
                        resp.response.modAPIUrl = 'https://api-netxselect.wsodqa.com';
                        this.renderDojoWidget(resp.response);
                    }
                }
            );
        }
    }

    gotoRoute(page: string): void {
        if (this.inputValue === 'ALL_ACCOUNTS' || this.group) {
            this.nxiRestService.getAccountList().subscribe(data => {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].primaryAcct) {
                        this.acctRef = data[i].acctReference;
                        document.dispatchEvent(new CustomEvent('portal.gotoview', {
                            detail: {
                                'gotoPage': page,
                                'context': { 'domain': 'account', 'value': this.acctRef }
                            }
                        }));
                        break;
                    }
                }
            },
            error => {
            });
        } else {
            document.dispatchEvent(new CustomEvent('portal.gotoview', {
                detail: {
                    'gotoPage': page,
                    'context': { 'domain': 'account', 'value': this.acctRef }
                }
            }));
        }
    }

}
